const limitNotif = (value) => {
	if (parseInt(value) > 99) {
		return "99+";
	} else {
		return value;
	}
};

export { limitNotif };
